<template>
  <div class="flex flex-wrap">

    <div class="w-full title lg:w-1/4">
      <h4 class="ads-list-title">
        Ads List
      </h4>
    </div>

    <div class="grid grid-cols-1 w-full mb-4w lg:w-3/4 lg:gap-4 lg:grid-cols-4">

      <!-- search Asd Filter -->
      <speakol-input
        id="ads-search-ads-input"
        placeholder="Search ads"
        v-model="filters.searchQuery"
        icon="speakol-search"
        class="mb-4 w-full lg:mb-0"
      />

      <!-- Select All Account droplist -->
        <speakol-checkbox-tree
        id="ads-all-accounts-list"
        class="w-full mb-6 md:mb-0 md:input md:mr-4"
        :fetchFunction="getSubAccountsOptions"
        :includeAll="true"
        v-if="$hasAnyFeature('sub-accounts') && hasSubAccounts"
        placeholder="All Accounts"
        @input="handleSubAccountSelected"
        singleMaxWidth="130px"
        multipleMaxWidth="140px"
      />

      <!-- Select All status droplist -->
      <speakol-select
        id="ads-all-status-list"
        class="w-full mb-4 lg:mb-0"
        placeholder="All Status"
        :options="filterOptions.status"
        v-model="filters.status"
      />

      <!-- Select All Campaigns droplist -->
      <speakol-checkbox-tree
        id="ads-all-campaigns-list"
        class="w-full mb-6 md:mb-0 md:input md:mr-4"
        :fetchFunction="getCampaignsOptions"
        :includeAll="true"
        placeholder="All Campaigns"
        ref="campaigns-filter"
        @input="handleCampaignSelected"
        singleMaxWidth="130px"
        multipleMaxWidth="140px"
      />

      <!-- Select All Adsets droplist -->
      <speakol-checkbox-tree
        id="ads-all-adsets-list"
        class="w-full mb-6 md:mb-0 md:input md:mr-4"
        :fetchFunction="getAdsetOptions"
        :includeAll="true"
        placeholder="All Ad Sets"
        ref="adsets-filter"
        @input="handleAdsetsSelected"
        singleMaxWidth="130px"
        multipleMaxWidth="130px"
      />

      <div v-if="!$hasAnyFeature('sub-accounts') || !hasSubAccounts" ></div>

      <!-- Select All Events droplist -->
      <speakol-select
        id="ads-all-events-list"
        class="mb-4 w-full lg:mb-0"
        placeholder="Conversions"
        :options="filterOptions.events"
        v-model="filters.event"
      />


      <!-- Date Range Picker -->
      <speakol-date-range-picker
        id="ads-date-range-picker-input"
        v-on:date-change="handleDateFilterChanged"
        class="mb-8 w-full lg:mb-0"
        placeholder="Filter by date"
        :dateRange="filters.date"
        :minimumDate="minDate"
        :ignoreDefault="true"
      />

      <!-- change lg:grid-cols-1 to lg:grid-cols-2 when adding the export button -->
      <div class="w-full mb-4 grid  lg:grid-cols-2  lg:gap-4 lg:mb-0">

        <div class="w-full mb-4 lg:mb-0">
          <button id="ads-filter-button" class="filter-btn w-full filter-btn" @click="handleFilterClicked">
            Filter
          </button>
        </div>

        <div class="w-full">
          <button id="ads-export-button" type="border" class="export-btn w-full" @click="isExportPopupActive=true" :class="{'export-btn-disabled': isExportButtonDisabled}" :disabled="isExportButtonDisabled">
            Export
          </button>
        </div>
      </div>
    </div>

    <SpeakolExport :fileName="'Adslist'" :isActive="isExportPopupActive" exportType="ads-list" :params="{...filters, ...exportSortModel}" @hide="isExportPopupActive=false" :columns="visibleColumns" />
  </div>
</template>

<script>

import {isEmpty, without} from 'lodash'
import accountsTree from  '@/helpers/accountsTree'
import SpeakolExport from  '@/components/SpeakolExport'

export default {
  name: 'Header',
  props: {
    isExportButtonDisabled: {
      type: Boolean,
      default: false
    },
    exportSortModel: {
      type: Object,
      required: true
    },
    selectedAds: {
      default: 0
    },
    hasSubAccounts: {
      default: true
    }, 
    visibleColumns: {
      type: Array
    }
  },
  components: {
    SpeakolExport
  },
  data () {
    return {
      isExportPopupActive: false,
      minDate: this.calculateMinDate(),
      filters: {
        searchQuery: null,
        accountsIds: null,
        campaignsIds: null,
        event: null,
        status: null,
        adsetsIds: null,
        date: {
          startDate: this.calculateStartDate(),
          endDate: new Date()
        }
      },
      filterOptions: {
        status: [
          {
            id: null,
            text: 'All Status'
          },
          {
            id: 'Active',
            text: ' Active'
          },
          {
            id: 'Paused',
            text: 'Inactive'
          }
        ],
        events: [
          {
            id: 'conversions',
            text: 'Conversions'
          },
          {
            id: 'leads',
            text: 'Leads'
          },
          {
            id: 'install',
            text: 'App Installs'
          },
          {
            id: 'add_to_wishlist',
            text: 'Add To Wishlist'
          },
          {
            id: 'add_to_cart',
            text: 'Add To Cart'
          },
          {
            id: 'sign_up',
            text: 'Sign Up'
          },
          {
            id: 'purchase',
            text: 'Purchase'
          }
        ]
      }
    }
  },

  computed: {
    statusBarVisible () {
      return this.selectedAds !== 0
    }

  },

  methods: {

    // date values
    calculateStartDate () {
      const accountCreatedAt = new this.$moment(this.$store.getters['authentication/activeAccount'].created_at)
      return accountCreatedAt.format('YYYY-MM-DD')
    },

    calculateMinDate () {
      return new Date(new this.$moment(this.$store.getters['authentication/activeAccount'].created_at).subtract(1, 'days'))
    },

    handleDateFilterChanged (date) {
      this.filters.date.startDate = this.$moment(date.startDate).format('YYYY-MM-DD')
      this.filters.date.endDate = this.$moment(date.endDate).format('YYYY-MM-DD')
    },

    // Get Accounts Options //
    async getSubAccountsOptions () {
      return await accountsTree.maptToTree()
    },


    // Get Campaigns Options //
    async getCampaignsOptions (accountsIds = null) {
      const allCampaigns = await this.getCampaigns()
      const campaigns =  !accountsIds || isEmpty(accountsIds) ? allCampaigns : this.filterCampaignsByAccountsIds({ accountsIds, campaigns: allCampaigns })
      return campaigns.map((obj) => {
        const { id, name } = obj
        return {
          id,
          label: name
        }
      })
    },

    async getCampaigns () {
      const {data: response} = await window.axios.get('/campaigns/get-user-account-campaigns-without-full-details', {
        params: {
          include_children: true
        }
      })

      if (response.success) {
        return response.payload
      }
      return []
    },

    filterCampaignsByAccountsIds ({ accountsIds = [], campaigns = [] }) {
      return campaigns.filter(campaign => {
        return accountsIds.indexOf(campaign.account_id) !== -1
      })
    },


    // Get Adsets //
    async getAdsetOptions (options = { accountsIds: [], campaignsIds: [] }) {
      const adsets = await this.getAdsets(options)
      return adsets.map((obj) => {
        const { id, name } = obj
        return {
          id,
          label: name
        }
      })
    },

    async getAdsets (options = { accountsIds: [], campaignsIds: [] }) {
      const {data: response} = await window.axios.post('/recommendations/get/adsets', {
        accounts: options.accountsIds,
        campaigns: options.campaignsIds
      })

      if (response.success) {
        return response.payload
      }
      return []
    },

    // Handling Adsets Selected //
    handleAdsetsSelected (selectedAdsetsIds) {
      this.setAdsetsIdsSelected(without(selectedAdsetsIds, -1))
    },

    setAdsetsIdsSelected (adsetsIds) {
      this.filters.adsetsIds = adsetsIds
    },

    // Handling Campaign Selected //
    handleCampaignSelected (selectedCampaignsIds) {
      const campaignsIds = without(selectedCampaignsIds, -1)
      this.refreshAdsOptions({ accountsIds: [], campaignsIds })
      this.setCampaignsSelected(selectedCampaignsIds)
    },

    setCampaignsSelected (campaignsIds) {
      this.filters.campaignsIds = campaignsIds
    },

    // Handling Sub Account Selected  //
    handleSubAccountSelected (selectedAccountsIds) {
      const accountsIds = without(selectedAccountsIds, -1)
      this.refreshCampaignsOptions(accountsIds)
      this.refreshAdsOptions({ accountsIds, campaignsIds: [] })
      this.setSelectedAccounts(accountsIds)
    },

    refreshCampaignsOptions (accountsIds) {
      this.$refs['campaigns-filter'].callFetchFunction(accountsIds)
    },

    refreshAdsOptions (options = { accountsIds: [], campaignsIds: [] }) {
      this.$refs['adsets-filter'].callFetchFunction(options)
    },


    setSelectedAccounts (accountsIds) {
      this.filters.accountsIds = accountsIds
    },


    // Handling Filter is clicked //
    handleFilterClicked () {
      const clonedFilters = this.clone(this.filters)
      clonedFilters['searchQuery'] = isEmpty(clonedFilters['searchQuery']) ? null : clonedFilters['searchQuery']
      clonedFilters['accountsIds'] = isEmpty(clonedFilters['accountsIds']) ? null : clonedFilters['accountsIds']
      clonedFilters['campaignsIds'] = isEmpty(clonedFilters['campaignsIds']) ? null : clonedFilters['campaignsIds']
      clonedFilters['event'] = isEmpty(clonedFilters['event']) ? null : clonedFilters['event']
      clonedFilters['status'] = isEmpty(clonedFilters['status']) ? null : clonedFilters['status']
      clonedFilters['adsetsIds'] = isEmpty(clonedFilters['adsetsIds']) ? null : clonedFilters['adsetsIds']
      clonedFilters['date'] = isEmpty(clonedFilters['date']) ? null : clonedFilters['date']
      this.$emit('filter', clonedFilters)
    },


    clone (obj) {
      return JSON.parse(JSON.stringify(obj || {}))
    }


  }
}
</script>


<style lang="scss" scoped>

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    letter-spacing: 0.1px;
    color: #2c2c2c;

    @apply mb-6;
  }

  .filter-btn {
    background: #0092d7;
    color: white;
    box-sizing: border-box;
    border-radius: 3px;
    border: none;
    height: 40px;
    cursor: pointer;
    outline: none;
    box-shadow: none;
  }

  .export-btn {
    background: #fff;
    border: 1px solid #0092d7;
    color: #0092d7;
    box-sizing: border-box;
    border-radius: 3px;
    height: 40px;
    cursor: pointer;
  }

  .export-btn-disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }

  .ads-list-title {
    font-size: 24px;
  }

  @media (max-width: 576px) {
    .ads-list-title {
      font-size: 18px;
    }
  }
</style>

